import React from "react";
import { PopupForm } from "../../common/Style";
import { dateFormat } from "../../common/others/Functions";

const GetPaymentDetails = ({ data }) => {
  let records = (parseFloat(data.deal) * parseFloat(data.records)).toFixed(2);
  let paybox =
    data.paybox !== "" && data.paybox !== null ? parseFloat(data.giftCost) : 0;
  let digitalSeatCost = data.isDigitalSeat
    ? parseFloat(data.digitalSeatCost)
    : 0;
  let sum =
    parseFloat(records) +
    parseFloat(paybox) +
    parseFloat(digitalSeatCost) -
    parseInt(data.mikdama);

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
      style={{ padding: "20px" }}
    >
      <table style={{ textAlign: "center", width: "90%", margin: "0 auto" }}>
        <tr>
          <th></th>
          <th>כמות</th>
          <th>מחיר (₪)</th>
          <th style={{ width: "max-content" }}>סה״כ (₪)</th>
        </tr>

        <tr>
          <th>רשומות</th>
          <td>{data.records}</td>
          <td>{data.deal}</td>
          <td style={{ background: "#e1e9f7" }}>{records}</td>
        </tr>
        {data.paybox !== "" && data.paybox !== null && (
          <tr>
            <th>מתנות באשראי</th>
            {/* <td>{data.paybox !== "" && data.paybox !== null ? 1 : 0}</td>
            <td>{data.giftCost}</td> */}
            <td></td>
            <td></td>
            <td style={{ background: "#e1e9f7" }}>{paybox}</td>
          </tr>
        )}
        {data.isDigitalSeat && (
          <tr>
            <th>הושבה</th>
            {/* <td>{data.isDigitalSeat ? 1 : 0}</td>
            <td>{data.digitalSeatCost}</td> */}
            <td></td>
            <td></td>
            <td style={{ background: "#e1e9f7" }}>{digitalSeatCost}</td>
          </tr>
        )}
        <tr>
          <th>מקדמה</th>
          <td></td>
          <td></td>
          <td style={{ background: "#e1f7e7" }}>{data.mikdama}</td>
        </tr>
        <tr>
          <th>סה״כ לתשלום</th>
          <td></td>
          <td></td>
          <td style={{ background: "#f7ebe1" }}>{sum}</td>
        </tr>
      </table>
      <div
        style={{
          margin: "20px auto",
          fontSize: "18px",
          fontWeight: "bolder",
        }}
      >
        {`ניתן להסדיר תשלום החל מתאריך ${dateFormat(data.executionDate)}`}
      </div>
    </PopupForm>
  );
};

export default GetPaymentDetails;
